import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import {
  ProjectAssigneePicker,
  ProjectAssigneePickerProps,
} from '../assignee-picker';
import { Option } from './types';

interface TaskAssigneePickerProps {
  projectId: ProjectId;
  taskId?: number;
  value?: Option[];
  onChange?: (value: Option[], resolveCallback?: (value) => void) => void;
  isPrivate?: boolean;
  canShowTeams?: boolean;
  isMini?: boolean;
}

interface Props extends TaskAssigneePickerProps, ProjectAssigneePickerProps {}

export const TaskAssigneePicker: FC<Props> = (props) => {
  const { onChange, ...rest } = props;

  return (
    <ProjectAssigneePicker onDone={onChange} onSave={onChange} {...rest} />
  );
};
